/**
 * The operator's atypical-airspace (ARC-a) declaration of a mission (PUT/DELETE
 * /missions/{id}/atypical_airspace_declaration): the reasons a)–e) as the backend's
 * AtypicalAirspaceReasons wire values and the note rules of AtypicalAirspaceDeclarationRules.NoteProblem,
 * so the form never sends a declaration the server would refuse for its note. The zone checks of a), c)
 * and d) run only on the server.
 */

/** Wire values of the reasons a)–e), in that order. */
export const ATYPICAL_REASONS = ['tsa_tra', 'notam', 'prohibited_area_permit', 'very_low_altitude', 'obstacle_proximity'];

/** Longest note the server accepts. */
export const ATYPICAL_NOTE_MAX_LENGTH = 1000;

/** Whether the reason needs a note (a reference, a number or the obstacle); every reason except d). */
export const isAtypicalNoteRequired = (reason) => reason !== 'very_low_altitude';

/**
 * What stops the declaration from being saved: `reasonRequired` without a known reason, `noteRequired`
 * without a note the reason needs, `noteTooLong` above the limit (counted after trimming, as the
 * server stores it); null when it can be sent.
 */
export const atypicalDeclarationProblem = (reason, note) => {
  if (!ATYPICAL_REASONS.includes(reason)) return 'reasonRequired';
  const trimmed = (note || '').trim();
  if (trimmed.length > ATYPICAL_NOTE_MAX_LENGTH) return 'noteTooLong';
  if (!trimmed && isAtypicalNoteRequired(reason)) return 'noteRequired';
  return null;
};

/** The request body: the note trimmed, null when empty. */
export const atypicalDeclarationPayload = (reason, note) => ({
  reason,
  note: (note || '').trim() || null,
});
